export const OPERADORAS = [
  { nombre: "Orange", color: "#FF6600", servicios: "Fibra + Móvil + Prepago" },
  { nombre: "Digi", color: "#00205B", servicios: "Fibra + Móvil + Prepago" },
  { nombre: "MásMóvil", color: "#FFD100", servicios: "Fibra + Móvil + Prepago", textDark: true },
  { nombre: "O2", color: "#0050FF", servicios: "Fibra + Móvil" },
  { nombre: "Lowi", color: "#E60012", servicios: "Fibra + Móvil + Prepago" },
  { nombre: "Lebara", color: "#5BC0EB", servicios: "Móvil + Prepago" },
  { nombre: "Llamaya", color: "#FFFFFF", servicios: "Móvil + Prepago", textColor: "#0033A0" },
];
